import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import { KOSTENTRAEGER } from '../../../../../../../lib/constants/constant';
import EigenmittelMA, { getFormStrucEigenmittelMA } from './EigenmittelMA';

// import schemas
import MittelabrufSchema from '../../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;

export const GetEigenmittelMA = (application: any, readOnly: boolean) => {
	const OrgaStruc = [
		{
			label: get(
				application,
				MA_P.Foerderantrag.schema.attributes.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path,
				`Antragsteller`
			),
			content: <EigenmittelMA kostentraeger={KOSTENTRAEGER.Antragsteller} unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: getFormStrucEigenmittelMA(application, 'Antragsteller', get(getLocalstorageToken(), 'organisationId'), readOnly),
		},
	];
	const PartnerStruc = get(application, MA_P.Foerderantrag.schema.attributes.Verbundpartner.path, []).map((ele: any, i: number) => {
		return {
			label: get(
				ele,
				MA_P.Foerderantrag.schema.attributes.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					MA_P.Foerderantrag.schema.attributes.Verbundpartner.path.length + 1
				),
				`Verbundpartner ${i + 1}`
			),
			content: <EigenmittelMA kostentraeger={KOSTENTRAEGER.Verbundpartner} unternehmenId={get(ele, 'Verbundpartner.id')} />,
			formStruc: getFormStrucEigenmittelMA(application, 'Verbundpartner', get(ele, 'Verbundpartner.id'), readOnly),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
